import LayoutComponent from "../components/layout/LayoutComponent";
import '../styles/document.css';
import React from "react";
import {useHistory} from "react-router-dom";
import {linkLogo} from "../components/layout/Header";

function Impressum(props) {
    const history = useHistory();

    const handleClick = (url) => {
        history.push(url);
    }
    return (
        <LayoutComponent>
            <div className={"container-doc"}>

                    <div className="back-to-home"  onClick={
                        () => handleClick("/home")
                    }>
                        <img
                            src={linkLogo}
                            width={"50px"} height={"50px"}
                            alt=""/>
                    </div>

                <h1>
                    Impressum
                </h1>
                <h2>
                    Kando GmbH
                </h2>
                <ul>
                    <li>
                        • Am Bahnhof 3 09599 Freiberg •
                    </li>
                </ul>
                <ul>
                    <li>
                        Kontakt:
                    </li>
                    <li> Tel.: +4937312188290</li>
                    <li>E-Mail: info.kando.freiberg@gmail.com</li>
                    <li>Geschäftsführer: Nguyen, Huu Chuan</li>
                    <li>Handelsregister: HRB 35974</li>
                    <li>Registergericht: Amtsgericht Chemnitz</li>
                    <li>Umsatzsteuer-ID</li>
                    <li>Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz: DE 362814482</li>
                </ul>

            </div>
        </LayoutComponent>
    )
}

export default Impressum;